module.exports = __webpack_public_path__ + "media/images/animations/axle_spacing/3-f1a6a38714fa31abc34e8f6b4a2a098e.png";